/* eslint-disable no-unused-vars */

// Dependencies
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import uuid from 'react-uuid';
import parse from 'html-react-parser';
import { Link } from 'gatsby';

// Components
import Image from '../../../image/image';
import Modal from '../../../modal/modal';
import BlogAuthorSocial from '../../../blog/blogAuthorSocial/blogAuthorSocial';

// Utilities
import slugify from '../../../../utilities/slugify';

// Styles
import TeamMemberStyles from './teamMember.styles';

export default function TeamMember({ teamMember }) {
  const [currentModal, setCurrentModal] = useState(null);

  const teamMemberId = slugify(teamMember?.title);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const urlSearchParams = new URLSearchParams(window.location.search);
      const params = Object.fromEntries(urlSearchParams.entries());
      const currentTeamMember = params['team-member'];
      setCurrentModal(currentTeamMember);
    }
  }, [setCurrentModal]);

  const handleOpenModal = () => {
    setCurrentModal(teamMemberId);

    if (typeof window !== 'undefined')
      window.history.replaceState({}, '', `?team-member=${teamMemberId}`);
  };

  const handleCloseModal = () => {
    setCurrentModal(null);
  };

  return (
    <TeamMemberStyles className="team-member">
      <button onClick={handleOpenModal} type="button">
        <div className="top">
          <Image
            image={teamMember?.featuredImage?.node}
            filter={false}
            className="headshot"
          />

          <div className="overlay" />
        </div>

        <div className="bottom">
          <h3 className="name">{teamMember?.title}</h3>
          <h4 className="job-title">{teamMember?.teamMembers?.jobTitle}</h4>
          <div className="btn text-only view-bio">View Bio</div>
        </div>
      </button>

      <Modal
        modalId={teamMemberId}
        modalUrlKey="team-member"
        currentModal={currentModal}
        handleClose={handleCloseModal}
        header={
          <div>
            <h3 className="name">
              {teamMember?.title} &mdash;
              <span className="job-title">
                {' '}
                {teamMember?.teamMembers?.jobTitle}
              </span>
            </h3>

            <h3 className="offices">
              {teamMember.teamOffices.nodes.map((office, i) => (
                <span key={uuid()}>
                  {office.name}{' '}
                  {teamMember.teamOffices.nodes.length - 1 !== i ? '|' : ''}{' '}
                </span>
              ))}
            </h3>

            <BlogAuthorSocial
              author={{ blogProfile: teamMember?.teamMembers }}
            />
          </div>
        }
      >
        <div>
          <Image
            image={teamMember?.featuredImage?.node}
            filter={false}
            className="headshot"
            loading="eager"
            placeholder="none"
          />
          {parse(teamMember?.teamMembers?.bio)}
        </div>

        <div className="btn-group">
          {teamMember?.title === 'Rachel MacLynn' && (
            <Link to="/about-rachel-maclynn" className="btn dark small">
              More About Rachel
            </Link>
          )}

          <Link to="/how-we-work" className="btn dark small">
            How We Work
          </Link>

          <Link to="/success-stories" className="btn dark small">
            Success Stories
          </Link>
        </div>
      </Modal>
    </TeamMemberStyles>
  );
}

TeamMember.propTypes = {
  teamMember: PropTypes.shape({
    title: PropTypes.string,
    teamMembers: PropTypes.shape({
      jobTitle: PropTypes.string,
      bio: PropTypes.string,
    }),
    author: PropTypes.shape({
      node: PropTypes.shape({
        blopProfile: PropTypes.shape({}),
      }),
    }),
    teamOffices: PropTypes.shape({
      nodes: PropTypes.arrayOf(PropTypes.shape({})),
    }),
    featuredImage: PropTypes.shape({
      altText: PropTypes.string,
      node: PropTypes.shape({
        gatsbyImage: PropTypes.shape({}),
      }),
    }),
  }).isRequired,
};
